var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 15.1666H5.99992C2.37992 15.1666 0.833252 13.62 0.833252 9.99998V5.99998C0.833252 2.37998 2.37992 0.833313 5.99992 0.833313H9.99992C13.6199 0.833313 15.1666 2.37998 15.1666 5.99998V9.99998C15.1666 13.62 13.6199 15.1666 9.99992 15.1666ZM5.99992 1.83331C2.92659 1.83331 1.83325 2.92665 1.83325 5.99998V9.99998C1.83325 13.0733 2.92659 14.1666 5.99992 14.1666H9.99992C13.0733 14.1666 14.1666 13.0733 14.1666 9.99998V5.99998C14.1666 2.92665 13.0733 1.83331 9.99992 1.83331H5.99992Z",
    fill: "#007BFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05321 10.3867C6.91988 10.3867 6.79321 10.3333 6.69988 10.24L4.81321 8.35334C4.61988 8.16 4.61988 7.84 4.81321 7.64667C5.00655 7.45334 5.32655 7.45334 5.51988 7.64667L7.05321 9.18L10.4799 5.75334C10.6732 5.56 10.9932 5.56 11.1865 5.75334C11.3799 5.94667 11.3799 6.26667 11.1865 6.46L7.40655 10.24C7.31321 10.3333 7.18655 10.3867 7.05321 10.3867Z",
    fill: "#007BFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.33ffefb258266eb1151017f51451bb2a.svg";
export { ForwardRef as ReactComponent };